// extracted by mini-css-extract-plugin
module.exports = {"MultipleChoice":"MultipleChoice_MultipleChoice__5FOnW","MultipleChoice__radio":"MultipleChoice_MultipleChoice__radio__B-6Tp"};